import React, { ReactNode } from 'react'

import { Listbox as HeadlessListbox, ListboxProps } from '@headlessui/react'

import Button, { IButton } from '@/components/common/Listbox/Button'
import Option, { IOption } from '@/components/common/Listbox/Option'
import Options, { IOptions } from '@/components/common/Listbox/Options'

import TransitionContext from '@/context/Transition'

interface IListbox extends ListboxProps<any, any, any> {
  children?: ReactNode
}

interface ListboxComponent extends React.FC<IListbox> {
  Button: typeof Button
  Option: typeof Option
  Options: typeof Options
}

const Listbox: ListboxComponent = ({ children, ...props }) => {
  return (
    <HeadlessListbox {...props}>
      {({ open }) => (
        <TransitionContext.Provider value={{ open }}>
          {children}
        </TransitionContext.Provider>
      )}
    </HeadlessListbox>
  )
}

Listbox.Button = Button
Listbox.Option = Option
Listbox.Options = Options

export { Button, Option, Options }

export default Listbox
